<template>
  <span v-if="party" class="party-size">
    <span class="party-size-text">
      <translate
        v-if="childrenCount > 0"
        :tt="{ adults: party.adults, childrenCount }"
      >
        {adults} adults, {childrenCount} children
      </translate>
      <translate
        v-else
        :tt="{ adults: party.adults }"
        class="adults"
        :class="{ 'has-dogs': hasDogs }"
        >{adults} adults</translate
      ><template v-if="hasDogs"
        >,&nbsp;
        <translate :tt="{ dogs }"> {dogs} dogs </translate>
      </template>
    </span>
  </span>
</template>

<script lang="ts">
import { SearchParty } from '../../../search/schemas'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class SearchWizardHomepageBannerOptionsParty extends Vue {
  @Prop({ required: true, type: [Object, String] })
  party: SearchParty | ''

  get childrenCount() {
    return this.party ? this.party.childAges.length : 0
  }

  get dogs() {
    return this.party && this.party.dogs ? this.party.dogs : 0
  }

  get hasDogs() {
    return this.dogs > 0
  }
}

export default toNative(SearchWizardHomepageBannerOptionsParty)
</script>
<style scoped>
span :deep(strong) {
  font-weight: normal;
}

.party-size {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
}

.adults {
  margin-right: 0.2em;
}

.adults.has-dogs {
  margin-right: unset;
}
</style>
